<template>
  <header class="header">
    <div class="header__text-box">
      <h1 class="heading-primary">
        <span class="heading-primary--main">Fornos</span>
        <span class="heading-primary--sub">building a house in Portugal</span>
      </h1>
    </div>
  </header>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
</style>
